export const PageLimitOptions: Array<number> = [10, 25, 50, 100, 200, 500, 1000];

export const initialPageLimit = 25;